import React, { Component } from "react";
import HasPermissionTo from "../../common/HasPermissionTo";
import AldCupidId from "./AldCupidId";
import LeadTimes from "./leadTimes/LeadTimes";
import SubNav from "../../shared/subnav/SubNav";
import PaymentThreshold from "./paymentThreshold/PaymentThreshold";
import TranslationDetails from "../translations/TranslationDetails";
import MerchantId from "./merchantId/MerchantId";
import AgentContract from "./customerContract/AgentContract";
import MarketDeliveryRanges from "./deliveryRanges/market/MarketDeliveryRanges";
import { withTranslation } from "react-i18next";
import NscNotifications from "./nscNotifications/NscNotifications";

class MarketBusinessSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: this.props.startingTab,
    };
  }

  handleTabChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  getTabs() {
    return [
      {
        menuName: this.props.t("ProgressBar.deliveryRanges"),
        enabled: true,
        id: "deliveryRanges",
      },
      {
        menuName: this.props.t("BusinessSettings.aldCupid"),
        enabled: true,
        id: "aldCupidId",
        hide: !this.props.user.permissions.rolePermissions.hasOwnProperty(
          "aldCupidIdTab"
        ),
      },
      {
        menuName: this.props.t("ProgressBar.leadTimes"),
        enabled: true,
        id: "leadTimes",
        hide: !this.props.user.permissions.rolePermissions.hasOwnProperty(
          "leadTimesTab"
        ),
      },
      {
        menuName: this.props.t("PaymentThreshold.tabCaption"),
        enabled: true,
        id: "paymentThreshold",
        hide: !this.props.user.permissions.rolePermissions.hasOwnProperty(
          "paymentThresholdTab"
        ),
      },
      {
        menuName: this.props.t("ProgressBar.translations"),
        enabled: true,
        id: "translations",
        hide: !this.props.user.permissions.rolePermissions.hasOwnProperty(
          "translationsTab"
        ),
      },
      {
        menuName: this.props.t("ProgressBar.bluesnapStoreId"),
        enabled: true,
        id: "storeId",
      },
      {
        menuName: this.props.t("ProgressBar.agentContract"),
        enabled: true,
        id: "agentContract",
      },
      {
        menuName: this.props.t("NscNotifications.tabName"),
        enabled: true,
        id: "nscNotifications",
      },
    ];
  }

  render() {
    return (
      <div>
        <SubNav
          dashboard={false}
          selectedTab={this.state.selectedTab}
          title={this.props.t("GlobalNavBar.settings")}
          action={this.handleTabChange}
          tabs={this.getTabs()}
          restrictDropdown={this.state.restrictDropdown}
          {...this.props}
        />
        <div className="pageWrapper">
          {this.state.selectedTab === 0 && (
            <MarketDeliveryRanges {...this.props} />
          )}
          <HasPermissionTo
            perform={["aldCupidIdTab"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={this.state.selectedTab === 1}
            render={() => {
              return (
                <AldCupidId
                  {...this.props}
                  selectedMarket={this.props.user.market}
                />
              );
            }}
          />
          <HasPermissionTo
            perform={["leadTimesTab"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={this.state.selectedTab === 2}
            render={() => (
              <LeadTimes
                {...this.props}
                selectedMarket={this.props.user.market}
              />
            )}
          />
          <HasPermissionTo
            perform={["paymentThresholdTab"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={this.state.selectedTab === 3}
            render={() => (
              <PaymentThreshold
                {...this.props}
                selectedMarket={this.props.user.market}
              />
            )}
          />
          <HasPermissionTo
            perform={["translationsTab"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={this.state.selectedTab === 4}
            render={() => (
              <TranslationDetails
                {...this.props}
                selectedMarket={this.props.user.market}
              />
            )}
          />
          <HasPermissionTo
            perform={["storeIdTab"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={this.state.selectedTab === 5}
            render={() => {
              return <MerchantId {...this.props} />;
            }}
          />

          {this.state.selectedTab === 6 && <AgentContract {...this.props} />}
          {this.state.selectedTab === 7 && (
            <NscNotifications
              {...this.props}
              selectedMarket={this.props.user.market}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation("emp")(MarketBusinessSettings);
